import React, { Component } from 'react';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputGroup } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import ContentWrapper from '../Layout/ContentWrapper';
import InputField from '../Common/inputField';
import IsEnabled from '../Common/isEnabled';

class CategoryForm extends Component {

    componentDidMount() {
      this.props.fetchGroups();
      this.props.resetCategory();
    }

    handleFormSubmit(formProps) {
      if (this.props.currentCategory) {
        if(!this.checkPermission("change_product_category"))
          this.props.editCategory(formProps);
        else
          alert("You have no permission!");
      }
      else this.props.createCategory(formProps, this.props.type);
    }

    checkPermission(permission) {
      return false;
    }

    getGroupOptions() {
      let groupOptions = [];
      if(this.props.groups) {
        this.props.groups.map(group => {
          groupOptions.push({value: group.ProductGroup_id, label: group.Name})
        })
      }
      return groupOptions;
    }

    renderGroups() {
      const { groups, groupIsLoading, groupError} = this.props;
      const groupOptions = this.getGroupOptions();
      if(groupIsLoading && !groupError) return <Spinner/>;
      if(groupError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(groupError)}</div></ContentWrapper>
      return (
        <Row>
          <Col sm={ 12 }>
              <div className="form-group">
                <label><Translate value="group" /></label>
                <Field name="ProductGroup_id" component={ Selection } options={groupOptions}/>
              </div>
          </Col>
        </Row>
      )
    }

    render() {
      const { handleSubmit, closeC, submitting, pristine, valid } = this.props;
      return (
        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
          <br/>
          <Row>
            <Col sm={ 6 }>
              <div className="form-group">
                <label><Translate value="category_name" /></label>
                  <Field name="Name" component={ InputField }/>
              </div>
            </Col>
            <Col sm = { 6 }>
              <div className="form-group">
                <label><Translate value="description" /></label>
                  <Field name="Description" component={ InputField }/>
              </div>
            </Col>
          </Row>
            {this.renderGroups()}
          <Field name="IsEnabled" component={ IsEnabled }/>
          <br/>
          <br/>
            <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="submit" /></button>
            <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeC(); } } ><Translate value="cancel" /></button>
          <Row>
            { this.props.isCreating || this.props.isEditing && <Spinner/> }
            { this.props.created && <ContentWrapper><label className="alert alert-success"><Translate value="saved" /></label></ContentWrapper>}
            { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
            { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
          </Row>
        </form>
      )
    }
}

export default CategoryForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/categoryForm.jsx